export default {
  colors: {
    primary: '--blue-800',
    secondary: '--neutral-800',
    success: '--green-800',
    error: '--red-1000',
    warning: '--orange-800',
    white: '--neutral-0',
    text: '--neutral-800',
  },
  fontSize: {
    xxs: '.75rem',
    xs: '.875rem',
    sm: '1rem',
    md: '1.125rem',
    lg: '1.25rem',
    xl: '1.375rem',
    xll: '2.5rem',
    xlll: '3.5rem',
    xh: '5.5rem',
    xhh: '6.25rem',
  },
  zIndex: {
    backdrop: 600,
    modal: 800,
    alert: 900,
  },
};
